import { useDebounce } from '@/hooks/use-debounce';
import { useEffect } from 'react';

export const adjustFontSizeToFitWidth = (element: HTMLElement): void => {
    if (!element.parentElement) {
        return;
    }

    const parentWidth = element.parentElement.clientWidth;
    const fontSize = parseInt(window.getComputedStyle(element).fontSize);

    const elementWidth = element.scrollWidth;

    if (elementWidth > parentWidth) {
        const newFontSize = Math.floor((parentWidth / elementWidth) * fontSize);
        element.style.fontSize = `${newFontSize}px`;
    }
};

export const useDynamicFontSize = (textRefs: React.RefObject<(HTMLElement | null)[]>, loading: boolean = false) => {
    const triggerResize = () => {
        textRefs?.current?.forEach((textElement) => {
            if (textElement) {
                adjustFontSizeToFitWidth(textElement);
            }
        });
    };
    const debouncedResize = useDebounce(triggerResize);

    useEffect(() => {
        if (loading) {
            return () => undefined;
        }

        textRefs.current?.forEach((textElement) => {
            if (textElement) {
                adjustFontSizeToFitWidth(textElement);
            }
        });
    }, [loading, textRefs]);

    useEffect(() => {
        window.addEventListener('resize', debouncedResize);

        return () => {
            window.removeEventListener('resize', debouncedResize);
        };
    }, []);

    return { triggerResize };
};
